import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var TabManager = /*#__PURE__*/function () {
  function TabManager() {
    _classCallCheck(this, TabManager);
  }
  return _createClass(TabManager, null, [{
    key: "manageTabs",
    value: function manageTabs(idFirstButton, idSecondButton) {
      var tabs = document.querySelectorAll('.js-segmented-tab');
      var firstComponent = document.querySelector('#included');
      var secondComponent = document.querySelector('#notIncluded');
      var firstButton = document.querySelector(idFirstButton);
      var secondButton = document.querySelector(idSecondButton);
      var currentUrl = window.location.href;
      if (currentUrl.includes(idFirstButton)) {
        secondButton.classList.add('segmented__button--selected');
        firstButton.classList.remove('segmented__button--selected');
        secondComponent.classList.add('kl-hidden');
        firstComponent.classList.remove('kl-hidden');
      } else if (currentUrl.includes(idSecondButton)) {
        firstButton.classList.add('segmented__button--selected');
        secondButton.classList.remove('segmented__button--selected');
        firstComponent.classList.add('kl-hidden');
        secondComponent.classList.remove('kl-hidden');
      }
      var _iterator = _createForOfIteratorHelper(tabs),
        _step;
      try {
        var _loop = function _loop() {
          var tab = _step.value;
          tab.addEventListener('click', function () {
            var content = tab.dataset.content;
            var segmentedContents = document.querySelectorAll('.js-segmented-content');
            var _iterator2 = _createForOfIteratorHelper(tabs),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var otherTab = _step2.value;
                otherTab.classList.remove('segmented__button--selected');
                otherTab.attributes['aria-selected'].value = 'false';
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            if (!tab.classList.contains('segmented__button--selected')) {
              tab.classList.add('segmented__button--selected');
              tab.attributes['aria-selected'].value = 'true';
            }
            var _iterator3 = _createForOfIteratorHelper(segmentedContents),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var segmentedContent = _step3.value;
                segmentedContent.classList.add('kl-hidden');
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            document.getElementById(content).classList.remove('kl-hidden');
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}();
export default TabManager;